var _path, _line, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDivider(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 271,
    height: 18,
    viewBox: "0 0 271 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.00146484 8.5L120.001 8.83488",
    stroke: "#CCCCCC"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 150.001,
    y1: 8.5,
    x2: 270.001,
    y2: 8.83488,
    stroke: "#CCCCCC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M130.621 12.247C130.384 12.4843 130.373 12.908 130.627 13.1566C130.875 13.4053 131.299 13.3996 131.537 13.1623L134.994 9.69878L138.458 13.1623C138.701 13.4053 139.119 13.4053 139.368 13.1566C139.611 12.9024 139.616 12.4899 139.368 12.247L135.91 8.78346L139.368 5.32559C139.616 5.08264 139.616 4.66453 139.368 4.41593C139.113 4.17297 138.701 4.16732 138.458 4.41028L134.994 7.87379L131.537 4.41028C131.299 4.17297 130.87 4.16167 130.627 4.41593C130.378 4.66453 130.384 5.08829 130.621 5.32559L134.085 8.78346L130.621 12.247Z",
    fill: "#CCCCCC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDivider);
export default __webpack_public_path__ + "static/media/divider.718a199af1f1ea2caef4a07395bd9100.svg";
export { ForwardRef as ReactComponent };